module.exports = __webpack_public_path__ + "img/101.38be058.svg";